'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _models_infos = _interopRequireDefault(require("Shared/models_infos"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const {
  app,
  qwest
} = window;
const NO_VALUE = null;
class ModelPickerWrapper extends _react.PureComponent {
  render() {
    const props = this.props;
    return /*#__PURE__*/_react.default.createElement(ModelPicker, props);
  }
}
exports.default = ModelPickerWrapper;
class ModelPicker extends _react.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    (0, _defineProperty2.default)(this, "state", {
      loading: false,
      data: [],
      id: String(++app.form_index),
      value: NO_VALUE,
      input_txt: ''
    });
    (0, _defineProperty2.default)(this, "ref", /*#__PURE__*/_react.default.createRef());
    (0, _defineProperty2.default)(this, "all_res_fetched", false);
    (0, _defineProperty2.default)(this, "getPickedOption", (id, data) => {
      const component = this,
        props = this.props,
        state = this.state;
      return (props.data ? [props.data] : []).concat(data || state.data).find(data => {
        var _data$model;
        return ((_data$model = data.model) === null || _data$model === void 0 ? void 0 : _data$model.id) === id;
      });
    });
    (0, _defineProperty2.default)(this, "searchModelData", function () {
      var _models_infos$props$m;
      let searched = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let id = arguments.length > 1 ? arguments[1] : undefined;
      const component = _this,
        props = _this.props,
        state = _this.state;

      // Prevent searched reset after picked item
      if (state.input_txt && props['retain-value'] === true && !searched) return;
      const all_res_fetched = !id && (!searched || !searched.trim());
      if (component.all_res_fetched && all_res_fetched === true) {
        if (state.loading === true) component.setState({
          loading: false
        });
        return;
      }
      component.all_res_fetched = all_res_fetched;
      component.setState({
        loading: true
      });
      qwest.post((0, _Routing.action)((_models_infos$props$m = _models_infos.default[props.model]) === null || _models_infos$props$m === void 0 ? void 0 : _models_infos$props$m.autocomplete_url), _objectSpread({
        searched: searched.trim(),
        id: id
      }, props['custom-query'] || {})).then(function (xhr, response) {
        const update = {
          loading: false,
          data: (response.data || []).filter(data => {
            var _data$model2, _props$data, _props$data$model;
            return ((_data$model2 = data.model) === null || _data$model2 === void 0 ? void 0 : _data$model2.id) !== ((_props$data = props.data) === null || _props$data === void 0 ? void 0 : (_props$data$model = _props$data.model) === null || _props$data$model === void 0 ? void 0 : _props$data$model.id);
          })
        };
        if (id) {
          const picked = component.getPickedOption(props.picked, response.data);
          update.value = picked || NO_VALUE;
        } else {
          update.value = NO_VALUE;
        }
        component.setState(update);
      }).catch(function (error, xhr, response) {
        console.error((response === null || response === void 0 ? void 0 : response.error) || (response === null || response === void 0 ? void 0 : response.raw) || error);
        component.setState(_objectSpread({}, (0, _getErrorsFromResponse.default)({
          response: response
        })));
      });
    });
    (0, _defineProperty2.default)(this, "selectValue", (event, data) => {
      var _data$model3, _data$model4;
      let component = this,
        props = this.props,
        state = this.state;
      let error_name = component.getStatusName();
      props.onPick({
        e: undefined,
        value: (data === null || data === void 0 ? void 0 : (_data$model3 = data.model) === null || _data$model3 === void 0 ? void 0 : _data$model3.id) || '',
        name: props.name,
        error_name: error_name,
        model: (data === null || data === void 0 ? void 0 : data.model) || {}
      });
      const update = {};
      if (props['retain-value'] === true) {
        Object.assign(update, {});
      } else {
        Object.assign(update, {
          value: props['clear-on-selection'] === true ? NO_VALUE : data || NO_VALUE,
          input_txt: props['clear-on-selection'] === true ? '' : (data === null || data === void 0 ? void 0 : data.label) || ''
        });
      }
      component.setState(update);
      if (!(data !== null && data !== void 0 && (_data$model4 = data.model) !== null && _data$model4 !== void 0 && _data$model4.id)) {
        component.searchModelData('');
      }
      if (props['clear-on-selection'] === true && props['retain-value'] !== true) {
        var _component$ref, _component$ref$curren;
        (_component$ref = component.ref) === null || _component$ref === void 0 ? void 0 : (_component$ref$curren = _component$ref.current) === null || _component$ref$curren === void 0 ? void 0 : _component$ref$curren.blur();
      }
    });
    (0, _defineProperty2.default)(this, "handleChange", event => {
      const component = this,
        props = this.props,
        state = this.state;
      let error_name = component.getStatusName();
      const searched = event.target.value;
      component.setState({
        input_txt: searched
      });
      if (component.search_timeout) {
        window.clearTimeout(component.search_timeout);
      }
      component.setState({
        loading: true
      });
      component.search_timeout = window.setTimeout(function () {
        component.search_timeout = undefined;
        component.searchModelData(searched);
      }, 600);
      if (!searched) {
        props.onPick({
          e: undefined,
          value: '',
          name: props.name,
          error_name: error_name
        });
      }
    });
    (0, _defineProperty2.default)(this, "handleFocus", () => {
      var _state$value;
      const component = this,
        props = this.props,
        state = this.state;
      if (!((_state$value = state.value) !== null && _state$value !== void 0 && _state$value.model)) {
        component.searchModelData();
      }
    });
    (0, _defineProperty2.default)(this, "handleBlur", () => {
      var _state$value2;
      const component = this,
        props = this.props,
        state = this.state;
      let error_name = component.getStatusName();
      if (props['retain-value'] === true) return;

      // Value has no match so it's cleared
      if (!((_state$value2 = state.value) !== null && _state$value2 !== void 0 && _state$value2.model) && props.picked) {
        component.setState({
          value: NO_VALUE,
          input_txt: ''
        });
        props.onPick({
          e: undefined,
          value: '',
          name: props.name,
          error_name: error_name
        });
      }
    });
    (0, _defineProperty2.default)(this, "getStatusName", () => {
      var _props$name;
      const component = this,
        props = this.props,
        state = this.state;
      if (props['error-name']) return props['error-name'];
      return !props['error-prefix'] ? props.name : ((_props$name = props.name) === null || _props$name === void 0 ? void 0 : _props$name.includes('[')) === true ? props['error-prefix'] + '[' + props.name.replace('[', '][') : props['error-prefix'] + '[' + props.name + ']';
    });
  }
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.picked) {
      component.searchModelData('', props.picked);
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.picked !== props.picked) {
      const picked = props.picked ? component.getPickedOption(props.picked) : '';
      if (picked) {
        component.setState({
          value: picked
        });
      } else if (prev_props.picked && !props.picked)
        // cleared
        {
          component.setState({
            value: NO_VALUE
          });
        } else {
        component.searchModelData('', props.picked);
      }
    }
  }
  render() {
    var _models_infos$props$m2, _state$value3;
    const component = this,
      props = this.props,
      state = this.state;
    const status_name = component.getStatusName();
    let base_class = 'c-model-picker',
      class_name = props.className || '';
    if (typeof props.bemit === 'string') {
      class_name += ' ' + base_class + '--' + props.bemit;
    } else {
      class_name += ' ' + base_class;
      props.bemit.forEach(function (bem_modifier, index) {
        class_name += ' ' + base_class + '--' + bem_modifier;
      });
    }
    const label = props.label || ((_models_infos$props$m2 = _models_infos.default[props.model]) === null || _models_infos$props$m2 === void 0 ? void 0 : _models_infos$props$m2.picker_label);
    let suggestions = props.data ? [props.data].concat(state.data) : undefined;
    if (props.filter) {
      suggestions = suggestions ? suggestions.filter(props.filter) : state.data.filter(props.filter);
    }
    let status = props.status_messages[status_name];
    const error_msg = status !== null && status !== void 0 && status.error ? status.error : undefined;
    let autocomplete_options = (suggestions || state.data || []).slice(0);
    let used_value = state.value;

    // Model picked but no results found
    if ((_state$value3 = state.value) !== null && _state$value3 !== void 0 && _state$value3.model && (state.data || []).length === 0) {
      used_value = {
        value: state.value.model,
        label: label || ''
      };
      autocomplete_options = [used_value];
    }
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name || base_class
    }, /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
      id: state.id,
      className: "m-ui-autocomplete",
      disabled: props['read-only'] === true,
      value: used_value,
      options: autocomplete_options,
      autoHighlight: true,
      noOptionsText: props['no-results-txt'],
      onChange: component.selectValue,
      getOptionLabel: data => data.label,
      loading: state.loading,
      filterOptions: options => options,
      isOptionEqualToValue: option => {
        var _option$model, _used_value, _used_value$model;
        return (option === null || option === void 0 ? void 0 : (_option$model = option.model) === null || _option$model === void 0 ? void 0 : _option$model.id) === ((_used_value = used_value) === null || _used_value === void 0 ? void 0 : (_used_value$model = _used_value.model) === null || _used_value$model === void 0 ? void 0 : _used_value$model.id);
      },
      renderInput: params => /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({}, params, {
        placeholder: props.label === false ? label : undefined,
        label: props.label === false ? undefined : label,
        onChange: component.handleChange,
        error: error_msg ? true : false,
        helperText: error_msg,
        onFocus: component.handleFocus,
        onBlur: component.handleBlur,
        name: props.name,
        variant: "standard",
        InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
          autoComplete: 'off',
          inputRef: component.ref,
          endAdornment: /*#__PURE__*/_react.default.createElement(_react.Fragment, null, state.loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        })
      }))
    }));
    return output;
  }
}
ModelPicker.propTypes = {
  model: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  value: _propTypes.default.string,
  'no-results-txt': _propTypes.default.string,
  status_messages: _propTypes.default.object,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.bool]),
  bemit: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  picked: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array])
};
ModelPicker.defaultProps = {
  bemit: [],
  'no-results-txt': 'Aucune correspondance.',
  status_messages: {}
};
